import { Injectable } from '@angular/core';

import { ResourceBaseUrlBuilder } from './api/resource-base-url-builder';
import { ClientQuery } from './client/client.query';
import { UserNamespacedResourceBaseUrlBuilder } from './user-namespaced-resource-base-url-builder.service';
import { standardizeUrl } from './utils';
import { AppStoreQuery } from './state';
import { EnvelopeQuery } from './envelope/envelope.query';
import { SignableDoument } from './models/signable-document.model';

/**
 * Builds the following backend URLs:
 *   - emittents/{emittent_uid}/clients/{client_uid}
 *   - investors/{investor_uid}/clients/{client_uid}
 */
@Injectable({ providedIn: 'root' })
export class ClientNamespacedResourceBaseUrlBuilder implements ResourceBaseUrlBuilder {
  constructor(
    private clientQuery: ClientQuery,
    private userNamespaceBuilder: UserNamespacedResourceBaseUrlBuilder,
    private appStoreQuery: AppStoreQuery,
    private envelopeQuery: EnvelopeQuery,
  ) {}

  public buildBaseUrl(append?: string): string {
    let clientsRoute = 'clients';
    const userNamespace = this.userNamespaceBuilder.buildBaseUrl();
    let clientId = this.clientQuery.getActiveId();

    // Guard: Don't build URL if no active organization (userNamespace is empty)
    if (!userNamespace) {
      return '';
    }

    if (clientId === undefined) {
      if (this.isEnvelopUrl()) {
        clientId = (this.envelopeQuery.getValue().signableDocument as SignableDoument)?.clientUid;
        clientsRoute = userNamespace.includes('emittents') ? 'client' : 'clients';
      } else {
        this.appStoreQuery.selectUserProfile().subscribe((user) => {
          clientId = user?.client?.uid;
        });
      }
    }

    // Guard: Don't build URL if no client ID (still undefined after all attempts)
    if (clientId === undefined || clientId === null) {
      return '';
    }

    let url = `${userNamespace}/${clientsRoute}/${clientId}`;

    if (append) {
      url += `/${append}`;
    }
    return standardizeUrl(url);
  }

  isEnvelopUrl(): boolean {
    return window.location.href.includes('envelopes');
  }
}
